module.exports = __webpack_public_path__ + "media/images/arrow_left-49edf1baf5ecb5a3e0a2214a6151b10f.svg";